<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <!-- Breadcrumbs -->
        <Breadcrumbs :items="items" />

        <v-card class="mx-auto" max-width="1000" elevation="1">
          <v-toolbar color="#343F53">
            <v-card-title
              class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
            >
              <span style="color: white">{{
                tipo
                  .split('-')
                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' ')
              }}</span>
            </v-card-title>
          </v-toolbar>

          <v-card-text>
            <v-form v-model="valid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editProfile.nome"
                    label="Nome"
                    density="compact"
                    :rules="[
                      (v) => !!v || 'Nome é obrigatório',
                      (v) =>
                        v.length <= 150 ||
                        'O nome deve ter no máximo 150 caracteres',
                    ]"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editProfile.email"
                    label="Usuário"
                    readonly
                    density="compact"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editProfile.data_nascimento"
                    density="compact"
                    type="date"
                    label="Data de Nascimento"
                    required
                  ></v-text-field>
                </v-col>

                <!-- <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editProfile.cpf"
                    label="CPF"
                    density="compact"
                    required
                    v-mask="'###.###.###-##'"
                  ></v-text-field>
                </v-col> -->

                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="editProfile.telefone"
                    label="Telefone"
                    readonly
                    density="compact"
                    hide-details
                    class="mb-2"
                  ></v-text-field>
                  <v-btn
                    variant="text"
                    color="primary"
                    density="compact"
                    class="text-none ml-2"
                    @click="opentelefoneDialog"
                  >
                    Cadastrar novo telefone
                  </v-btn>
                </v-col>

                <!-- <v-col cols="12" md="6">
                    <v-text-field
                      :value="'********'"
                      label="Senha"
                      readonly
                      class="mb-2"
                      density="compact"
                      hide-details
                    ></v-text-field>

                    <v-btn
                      variant="text"
                      color="primary"
                      density="compact"
                      class="text-none ml-2"
                      @click="openPasswordDialog"
                    >
                      Atualizar senha
                    </v-btn>
                  </v-col> -->
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#343F53" @click="saveProfile" :loading="loading">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-main>

    <!-- Dialog para alterar telefone -->
    <v-dialog v-model="telefoneDialog" max-width="700px">
      <v-card>
        <v-toolbar color="#343F53">
          <v-toolbar-title class="text-white"
            >Cadastrar novo telefone</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text class="pt-4" v-if="!loadingDialog">
          <v-form v-model="valid" class="pa-4">
            <v-row dense>
              <template v-if="!codigoEnviado">
                <v-col cols="12" class="d-flex justify-center">
                  <div
                    class="d-flex flex-column flex-md-row align-center"
                    style="max-width: 600px; width: 100%"
                  >
                    <v-text-field
                      :readonly="
                        codigoEnviado || loadingEnvioCod || loadingValidCod
                      "
                      v-model="editProfile.telefone"
                      :rules="[(v) => !!v || 'Telefone é obrigatório']"
                      label="Telefone do Moderador"
                      hide-details
                      v-mask="'(##) #####-####'"
                      required
                      class="custom-text-field flex-grow-1 mr-md-4"
                    >
                    </v-text-field>
                    <!-- Botão Iniciar Cadastro -->
                    <v-btn
                      color="#343F53"
                      :disabled="loadingEnvioCod"
                      @click="enviarToken"
                      size="small"
                      variant="outlined"
                      class="mt-3 mt-md-0"
                      :loading="loadingEnvioCod"
                    >
                      Iniciar Cadastro
                    </v-btn>
                  </div>
                </v-col>
              </template>

              <!-- Código de Verificação -->
              <v-col cols="12" md="12" v-if="isVisibleToken && !isVisible">
                <div class="d-flex align-center justify-center">
                  <span
                    >Insira o código de 5 dígitos que enviamos para o telefone
                    {{ editProfile.telefone }}</span
                  >
                </div>
                <v-otp-input
                  v-model="editProfile.token"
                  :disabled="loadingValidCod"
                  :length="5"
                  class="custom-otp-input"
                  hide-details
                  required
                ></v-otp-input>
              </v-col>

              <v-col cols="12" class="d-flex justify-center" v-if="!isVisible">
                <template v-if="codigoEnviado">
                  <!-- Botão Reenviar Código -->
                  <v-btn
                    color="#343F53"
                    :disabled="isWaiting || loadingEnvioCod || loadingValidCod"
                    @click="enviarToken"
                    size="small"
                    variant="outlined"
                    class="mr-2"
                    :loading="loadingEnvioCod"
                  >
                    {{
                      isWaiting
                        ? `Reenviar (${tempoRestante}s)`
                        : "Reenviar Código"
                    }}
                  </v-btn>
                </template>
                <v-btn
                  v-if="isVisibleToken"
                  color="#343F53"
                  @click="verificarToken()"
                  size="small"
                  variant="flat"
                  :disabled="loadingValidCod"
                  :loading="loadingValidCod"
                >
                  Validar Código
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card dark v-if="loadingDialog" elevation="0">
          <v-card-text class="pa-4 text-center">
            <v-progress-circular
              indeterminate
              color="#343F53"
              size="64"
              class="mb-3"
            ></v-progress-circular>
            <div class="text-h6 mt-2" style="color: #343f53">
              {{ loadingMessage }}
            </div>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" variant="text" @click="telefoneDialog = false"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para alterar senha -->
    <v-dialog v-model="passwordDialog" max-width="500px">
      <v-card>
        <v-toolbar color="#343F53">
          <v-toolbar-title class="text-white">Alterar Senha</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-4" v-if="!loadingDialog">
          <v-form v-model="passwordValid">
            <v-text-field
              v-model="editProfile.currentPassword"
              label="Senha Atual"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              :rules="[
                (v) =>
                  v.length >= 6 || 'A senha deve ter pelo menos 6 caracteres',
                (v) => !!v || 'Senha atual é obrigatória',
              ]"
              required
            ></v-text-field>

            <v-text-field
              v-model="novaSenha"
              label="Nova Senha"
              :type="showNewPassword ? 'text' : 'password'"
              :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showNewPassword = !showNewPassword"
              :rules="[
                (v) => !!v || 'Nova senha é obrigatória',
                (v) =>
                  v.length >= 6 || 'A senha deve ter pelo menos 6 caracteres',
              ]"
              required
            ></v-text-field>

            <v-text-field
              v-model="confirmPassword"
              label="Confirmar Nova Senha"
              :type="showConfirmPassword ? 'text' : 'password'"
              :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showConfirmPassword = !showConfirmPassword"
              :rules="[
                (v) => !!v || 'Confirmação de senha é obrigatória',
                (v) => v === novaSenha || 'As senhas não coincidem',
              ]"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card dark v-if="loadingDialog" elevation="0">
          <v-card-text class="pa-4 text-center">
            <v-progress-circular
              indeterminate
              color="#343F53"
              size="64"
              class="mb-3"
            ></v-progress-circular>
            <div class="text-h6 mt-2" style="color: #343f53">
              {{ loadingMessage }}
            </div>
          </v-card-text>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" variant="text" @click="passwordDialog = false"
            >Cancelar</v-btn
          >
          <v-btn
            color="#343F53"
            @click="savePassword"
            :disabled="!passwordValid || loadingDialog"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Footer />
  </v-app>
</template>

<script>
import Breadcrumbs from "@/components/utils/Breadcrumbs.vue";
import Navbar from "@/components/restrito/Navbar.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import Sidebar from "./Sidebar.vue";
import Footer from "./Footer.vue";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
  nome: "UserProfile",
  components: {
    Sidebar,
    Navbar,
    Footer,
    Breadcrumbs,
  },
  data() {
    return {
      loadingEnvioCod: false,
      loadingValidCod: false,
      validacaoModerador: false,
      moderadorExistente: false,
      isVisibleToken: false,
      codigoEnviado: false,
      isVisible: false,
      isWaiting: false,
      tempoRestante: 0,

      valid: false,
      passwordValid: false,
      loading: false,
      showPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      telefoneDialog: false,
      passwordDialog: false,
      confirmPassword: "",
      novaSenha: "",
      // Objeto original com dados fake
      profile: {
        id: 0,
        nome: "",
        email: "",
        data_nascimento: "",
        cpf: "",
        telefone: "",
        currentPassword: "",
      },
      // Objeto para edição
      editProfile: {
        nome: "",
        email: "",
        data_nascimento: "",
        cpf: "",
        telefone: "",
        currentPassword: "",
      },
      loadingDialog: false,
      loadingMessage: "Processando...",
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    tipo() {
      return this.$route.params.tipo;
    },
    items() {
      return [
        {
          title: "Início",
          disabled: false,
          href: "/admin/despedidas",
        },
        {
          title: this.tipo 
            ? this.tipo
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ') 
            : "Editar Perfil",
          disabled: true,
        },
      ];
    },
  },
  watch: {
    "$route.params.tipo": {
      handler(newTipo) {
        this.resetData();
        if (newTipo === "editar-moderador") {
          this.loadModerador();
        } else if (newTipo === "editar-perfil") {
          this.loadUserProfile();
        }
      },
      immediate: false,
    },
    "$route.params.id": {
      handler() {
        this.resetData();
        if (this.tipo === "editar-moderador") {
          this.loadModerador();
        } else if (this.tipo === "editar-perfil") {
          this.loadUserProfile();
        }
      },
      immediate: false,
    },
  },
  mounted() {
    if (this.tipo === "editar-moderador") {
      this.loadModerador();
    } else if (this.tipo === "editar-perfil") {
      this.loadUserProfile();
    }
  },
  methods: {
    validateForm() {
      // Validar apenas campos que tinham valor originalmente
      let isValid = true;

      // Verificar campos obrigatórios que tinham valor original
      if (this.profile.nome && !this.editProfile.nome) {
        isValid = false;
      }

      if (this.profile.email && !this.editProfile.email) {
        isValid = false;
      }

      if (this.profile.data_nascimento && !this.editProfile.data_nascimento) {
        isValid = false;
      }

      if (this.profile.cpf && !this.editProfile.cpf) {
        isValid = false;
      }

      if (this.profile.telefone && !this.editProfile.telefone) {
        isValid = false;
      }

      this.valid = isValid;
      return isValid;
    },
    resetData() {
      this.profile = {};
      this.editProfile = {};
      this.despedida = {};
      this.loading = false;
      this.valid = false;
    },
    loadModerador() {
      http
        .get(`cliente/moderador-despedida/${this.id}`, {
          headers: authHeader(),
        })
        .then((response) => {
          this.profile = response.data.pessoa;
          this.profile.email = response.data.email;
          this.editProfile = { ...this.profile };
          console.log(this.profile);
        })
        .catch((error) => {
          console.error("Erro ao consultar:", error);
        });
    },

    pararTemporizador() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.isWaiting = false;
      this.tempoRestante = 0;
    },
    async verificarToken() {
      if (!this.editProfile.token) {
        toast.error("Informe o código de verificação!");
        return;
      }
      this.loadingValidCod = true;
      this.loadingDialog = true;
      this.loadingMessage = "Verificando código...";
      const phoneTratado = this.editProfile.telefone.replace(/\D/g, "");

      // Parar o temporizador ao validar o código
      this.pararTemporizador();

      try {
        const response = await http.post(
          `validacao/verificar`, // Endpoint
          null,
          {
            params: {
              telefone: phoneTratado,
              token: this.editProfile.token,
            },
            headers: authHeader(),
          }
        );

        if (response.status === 200 && response.data.mensagem === "Sucesso") {
          this.codigoValidado = true;
          this.isVisible = true;
          this.validacaoModerador = true;
          this.pararTemporizador();
          this.valid = true;
          this.saveProfile();
        } else {
          toast.error("Código incorreto!");
          this.loadingDialog = false;
        }
      } catch (error) {
        console.error("Erro ao validar o token:", error);
        toast.error("Erro ao validar o token!");
        this.loadingDialog = false;
      }
      this.loadingValidCod = false;
    },
    async enviarToken() {
      try {
        const phoneTratado = this.editProfile.telefone.replace(/\D/g, "");
        this.loadingEnvioCod = true;
        if (!phoneTratado || phoneTratado.length !== 11) {
          toast.error("Informe um número de telefone válido!");
          return;
        }

        const response = await http.post(`validacao/salvar`, null, {
          params: {
            telefone: phoneTratado,
          },
          headers: authHeader(),
        });
        this.idDespedida = response.data.id;
      } catch (error) {
        console.error("Erro ao enviar token:", error);
        throw error;
      }
      this.loadingEnvioCod = false;
      this.isVisibleToken = true;
      this.codigoEnviado = true;
      this.iniciarTemporizador();
    },
    iniciarTemporizador() {
      this.isWaiting = true;
      this.tempoRestante = 150;

      // Se já houver um temporizador rodando, limpa ele antes de iniciar um novo
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.intervalId = setInterval(() => {
        if (this.tempoRestante > 0) {
          this.tempoRestante--;
        } else {
          this.isWaiting = false;
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }, 1000);
    },
    opentelefoneDialog() {
      this.editProfile = { ...this.profile };
      this.telefoneDialog = true;
    },
    openPasswordDialog() {
      this.passwordDialog = true;
      this.editProfile.currentPassword = "";
      this.novaSenha = "";
      this.confirmPassword = "";
    },
    loadUserProfile() {
      console.log("Carregando perfil...");
      http
        .get("cliente/perfil", {
          headers: authHeader(),
        })
        .then((response) => {
          this.profile = response.data.pessoa;
          this.profile.email = response.data.email;
          this.editProfile = { ...this.profile };
        })
        .catch((error) => {
          toast.error("Erro ao carregar perfil");
          console.error("Erro ao carregar perfil:", error);
        });
    },
    async verificarEmail(email) {
      try {
        const response = await http.post(`validacao/verificar-email`, null, {
          params: {
            email: email,
          },
          headers: authHeader(),
        });
        console.log(response.data);
        return response.data;
      } catch (error) {
        console.error("Erro ao validar o token:", error);
        return false;
      }
    },
    async saveProfile() {
      this.validateForm();
      if (!this.valid) {
        const toast = useToast();
        toast.error(
          "Por favor, preencha todos os campos obrigatórios que já tinham valor."
        );
        return;
      }

      this.loading = true;
      this.loadingDialog = true;
      this.loadingMessage = "Atualizando perfil...";

      if (this.editProfile.email != this.profile.email) {
        const emailValido = await this.verificarEmail(this.editProfile.email);
        if (!emailValido) {
          toast.error("Email inválido!");
          return;
        }
      }

      // Format date from DD/MM/YYYY to YYYY-MM-DD
      let formattedDate = "";
      if (this.editProfile.data_nascimento) {
        const dateParts = this.editProfile.data_nascimento.split("/");
        formattedDate =
          dateParts.length === 3
            ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
            : this.editProfile.data_nascimento;
      }

      // Remove phone mask
      const formattedPhone = this.editProfile.telefone
        ? this.editProfile.telefone.replace(/\D/g, "")
        : "";

      // Remove CPF mask
      const formattedCpf = this.editProfile.cpf
        ? this.editProfile.cpf.replace(/\D/g, "")
        : "";

      // No momento a rota será a mesma, mas caso seja necessário mudar update de um moderador explicitamente ou de um perfil logado
      const rota =
        this.tipo === "editar-moderador"
          ? "cliente/update-pessoa-moderador"
          : "cliente/update-pessoa-moderador";

      try {
        await http.post(
          rota,
          {
            pessoa: {
              id: this.editProfile.id,
              nome: this.editProfile.nome,
              data_nascimento: formattedDate,
              cpf: formattedCpf,
              telefone: formattedPhone,
              email: this.editProfile.email,
              senha: this.editProfile.senha,
            },
          },
          { headers: authHeader() }
        );

        this.loadModerador();
        this.telefoneDialog = false;
        toast.success(`${this.tipo === "editar-moderador" ? "Moderador" : "Perfil"} atualizado com sucesso!`);
        this.$router.push("/admin/despedidas");
      } catch (error) {
        toast.error("Erro ao atualizar perfil");
        console.error("Erro ao atualizar perfil:", error);
      } finally {
        this.loading = false;
        this.loadingDialog = false;
        this.telefoneDialog = false;
      }
    },
    async savePassword() {
      if (!this.passwordValid) return;

      this.loadingDialog = true;
      this.loadingMessage = "Atualizando senha...";

      // Format date from DD/MM/YYYY to YYYY-MM-DD
      let formattedDate = "";
      if (this.editProfile.data_nascimento) {
        const dateParts = this.editProfile.data_nascimento.split("/");
        formattedDate =
          dateParts.length === 3
            ? `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
            : this.editProfile.data_nascimento;
      }

      // Remove phone mask
      const formattedPhone = this.editProfile.telefone
        ? this.editProfile.telefone.replace(/\D/g, "")
        : "";

      // Remove CPF mask
      const formattedCpf = this.editProfile.cpf
        ? this.editProfile.cpf.replace(/\D/g, "")
        : "";

      // No momento a rota será a mesma, mas caso seja necessário mudar update de um moderador explicitamente ou de um perfil logado
      const rota =
        this.tipo === "editar-moderador"
          ? "cliente/update-pessoa-moderador"
          : "cliente/update-pessoa-moderador";
      try {
        await http.post(
          rota,
          {
            pessoa: {
              id: this.editProfile.id,
              nome: this.editProfile.nome,
              data_nascimento: formattedDate,
              cpf: formattedCpf,
              telefone: formattedPhone,
              email: this.editProfile.email,
              senha: this.novaSenha,
            },
          },
          { headers: authHeader() }
        );

        toast.success("Senha atualizada com sucesso");
        this.passwordDialog = false;
        this.editProfile.currentPassword = "";
        this.novaSenha = "";
        this.confirmPassword = "";
      } catch (error) {
        toast.error("Erro ao atualizar senha");
        console.error("Erro ao atualizar senha:", error);
      } finally {
        this.loadingDialog = false;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}
</style>
